import styled from 'styled-components'

const HeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export default HeaderLeftContainer
